import React from 'react';
import './PasswordChecklistItem.scss'
import HrbTranslate from '../../../language/HrbTranslate';
import {PropTypes} from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckSquare } from '@fortawesome/free-solid-svg-icons';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

const PasswordChecklistItem = (props) => {

  let checkIcon;

  if (props.isMet) {
    checkIcon = <FontAwesomeIcon icon={faCheckSquare} className="checklist-item-check"/>;
  } else {
    checkIcon = <FontAwesomeIcon icon={faExclamationTriangle} className="checklist-item-exclamation"/>;
  }
  return (
      <div>
        <span className="checklist-item-icon">{checkIcon}</span>
        <HrbTranslate text={"new_password." + props.item.requirement}/>
      </div>
  )
};

PasswordChecklistItem.propTypes = {
  isMet: PropTypes.bool.isRequired,
  item: PropTypes.object.isRequired
};

export default PasswordChecklistItem;